import {
  jb_modal_css_default
} from "./chunk.B5LF2HBS.js";
import {
  o
} from "./chunk.JWFNSUTT.js";
import {
  e as e2
} from "./chunk.3XLWIJBS.js";
import {
  reset_css_default
} from "./chunk.YAATWOBE.js";
import {
  Stackable
} from "./chunk.CED623EG.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  A,
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  e,
  n
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-modal/jb-modal.ts
var JbModal = class extends Initiable(Stackable(i)) {
  constructor() {
    super(...arguments);
    this.ARILABELS_DEFAULT = {
      close: "Close"
    };
    this.fullHeight = false;
    this.newAnimation = false;
  }
  firstUpdated() {
    if (this._introPromiseResolve) {
      window.setTimeout(() => {
        this._section.classList.add("visible");
        this._section.addEventListener("transitionend", (event) => {
          if (event.propertyName === "height") {
            this._introPromiseResolve(true);
          }
        });
        this._dialogElement.showModal();
        const focusFlyMain = document.querySelector("jb-focus-fly");
        if (focusFlyMain?._isVisible()) {
          document.dispatchEvent(new CustomEvent("jb-focus-fly:show", { bubbles: true, composed: true }));
        }
      }, 10);
    }
  }
  async intro() {
    return new Promise((resolve) => {
      this._introPromiseResolve = resolve;
    });
  }
  async outro() {
    return new Promise((resolve) => {
      if (!this.newAnimation) {
        this._section.classList.remove("visible");
      } else {
        resolve(true);
      }
      this._section.addEventListener("transitionend", (event) => {
        if (event.propertyName === "height") {
          resolve(true);
        }
      });
      this._dialogElement.close();
      setTimeout(() => {
        this.returnFocusTo?.focus();
        this._dialogElement.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
      }, 100);
    });
  }
  stacked() {
  }
  unstacked() {
    this.returnFocusTo?.focus();
    setTimeout(() => {
      document.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
    }, 350);
    this.remove();
  }
  _close() {
    this.dispatchEvent(
      new CustomEvent("jb-modal:close", {
        bubbles: true,
        composed: true
      })
    );
  }
  get _slottedChildren() {
    const slot = this.shadowRoot.querySelector("slot");
    return slot.assignedElements();
  }
  render() {
    return b`
      <dialog
        closedby="none"
        title="${this.ariaLabels?.label ?? A}"
      >
        <section
          class=${e2({
      modal: true,
      "modal--gray": this.color === "gray",
      "modal--blue": this.color === "blue",
      "new-animation": !!this.newAnimation,
      fullheight: !!this.fullHeight,
      visible: true
    })}
          style=${o({ zIndex: this.zIndex().toString() })}
        >
          <div class="modal__container">
            <div class="modal__header">
              <div class="header-left">
                <slot name="header-left"></slot>
              </div>
              <div class="${e2({ "modal__logo-wrap": true, "no-logo": !this.hasLogo })}">
                <jb-logo
                  ?isWhite=${this.color === "blue"}
                  .href=${this.logoLink}
                  .svgLogo=${this.svgLogo}
                  .ariaLabels=${{
      logoLabel: this.ariaLabels?.logoLabel,
      linkLabel: this.ariaLabels?.logoLinkLabel
    }}
                ></jb-logo>
              </div>
              <div class="modal__close-btn">
                <button
                  data-fly-tweak="0,0,-8,-4"
                  aria-label="${this.ariaLabels?.close ?? this.ARILABELS_DEFAULT.close}"
                  @click=${this._close}
                  @keydown=${(event) => {
      if (event.code === "Enter" || event.code === "Space") {
        this._close();
      }
    }}
                >
                  <jb-close-icon></jb-close-icon>
                </button>
              </div>
            </div>
            <div class="${e2({ modal__content: true, relative: !!this.relativeContent })}">
              <slot name="content"></slot>
            </div>
          </div>
        </section>
        <jb-focus-fly></jb-focus-fly>
      </dialog>
    `;
  }
};
JbModal.styles = [reset_css_default, jb_modal_css_default];
JbModal.shadowRootOptions = { ...i.shadowRootOptions, delegatesFocus: true };
__decorateClass([
  n({ type: Object })
], JbModal.prototype, "ariaLabels", 2);
__decorateClass([
  n()
], JbModal.prototype, "color", 2);
__decorateClass([
  n({ type: Boolean })
], JbModal.prototype, "fullHeight", 2);
__decorateClass([
  n({ type: Boolean })
], JbModal.prototype, "hasLogo", 2);
__decorateClass([
  n()
], JbModal.prototype, "logoLink", 2);
__decorateClass([
  n({ type: Boolean })
], JbModal.prototype, "newAnimation", 2);
__decorateClass([
  n({ type: Boolean })
], JbModal.prototype, "relativeContent", 2);
__decorateClass([
  n({ type: Object })
], JbModal.prototype, "returnFocusTo", 2);
__decorateClass([
  n()
], JbModal.prototype, "svgLogo", 2);
__decorateClass([
  e("dialog")
], JbModal.prototype, "_dialogElement", 2);
__decorateClass([
  e("section")
], JbModal.prototype, "_section", 2);
JbModal = __decorateClass([
  customElement("jb-modal")
], JbModal);

export {
  JbModal
};
